import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const TOTALS_ROW_KEYS = [
  'total-price',
  'total-references',
  'total-packages',
  'total-cbm',
  'total-containers',
] as const;

export function PurchaseOrderMainTotalsSkeleton() {
  return (
    <Card>
      <CardHeader>
        <Skeleton className='h-7 w-40' />
      </CardHeader>
      <CardContent>
        <div className='flex flex-col gap-3'>
          {TOTALS_ROW_KEYS.map((key) => (
            <div className='flex items-center justify-between gap-2' key={key}>
              <Skeleton className='h-4 w-32' />
              <Skeleton className='h-5 w-24' />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
